import { render, staticRenderFns } from "./simulador-analise.vue?vue&type=template&id=920d1408&"
import script from "./simulador-analise.vue?vue&type=script&lang=js&"
export * from "./simulador-analise.vue?vue&type=script&lang=js&"
import style0 from "./simulador-analise.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VDivider,VEditDialog,VMenu,VScaleTransition,VSimpleTable,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('920d1408')) {
      api.createRecord('920d1408', component.options)
    } else {
      api.reload('920d1408', component.options)
    }
    module.hot.accept("./simulador-analise.vue?vue&type=template&id=920d1408&", function () {
      api.rerender('920d1408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/simulador-analise.vue"
export default component.exports